// BTR: variant-gallery colour grouping (Bryn 2026-06-11).
// Dawn's product-info.js diff-syncs the MAIN gallery list against the
// server-rendered section HTML on variant change, but never touches the
// thumbnail strip. Our colour filter makes the thumbnails selection-
// dependent, so re-render them from the fetched HTML on every change,
// then rebind the click handlers media-gallery.js attached at construction.
(function () {
  function syncThumbnails(data) {
    try {
      var html = data.html;
      var sectionId = data.sectionId;
      var variant = data.variant;
      if (!html || !sectionId) return;
      var sourceSlider = document.getElementById('GalleryThumbnails-' + sectionId);
      var updatedSlider = html.getElementById('GalleryThumbnails-' + sectionId);
      if (!sourceSlider || !updatedSlider) return;
      var sourceList = sourceSlider.querySelector('ul');
      var updatedList = updatedSlider.querySelector('ul');
      if (!sourceList || !updatedList) return;
      sourceList.innerHTML = updatedList.innerHTML;
      if (typeof sourceSlider.initPages === 'function') sourceSlider.initPages();

      var gallery = document.getElementById('MediaGallery-' + sectionId);
      if (!gallery) return;

      // rebind thumbnail clicks (media-gallery.js only binds in its constructor)
      sourceList.querySelectorAll('[data-target]').forEach(function (item) {
        var button = item.querySelector('button');
        if (button && typeof gallery.setActiveMedia === 'function') {
          button.addEventListener('click', gallery.setActiveMedia.bind(gallery, item.dataset.target, false));
        }
      });

      var featuredMediaId = variant && variant.featured_media && variant.featured_media.id;
      if (featuredMediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(sectionId + '-' + featuredMediaId, true);
      }
    } catch (e) {
      console.error('btr-variant-gallery:', e);
    }
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      syncThumbnails(event && event.data ? event.data : {});
    });
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
})();
